import { render, staticRenderFns } from "./ComprometimentoDados.vue?vue&type=template&id=380660e8&"
import script from "./ComprometimentoDados.vue?vue&type=script&lang=js&"
export * from "./ComprometimentoDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports